export const Navbar = () => {
    return (
        <header className="px-6 py-4 md:py-2 flex flex-col md:flex-row md:justify-between md:items-center">
        <img 
          src="https://zvia.tech/assets/ZVIA_B.png" 
          alt="Description of image" 
          className="w-24 h-auto py-4 px-2"
        />
        {/* <nav className="space-x-6 font-inter hidden md:flex text-base">
          <a href="#blog" className="text-black hover:text-gray-700">item-1</a>
          <a href="#about" className="text-black hover:text-gray-700">item-2</a>
          <a href="#pricing" className="text-black hover:text-gray-700">item-3</a>
          <a href="#contact" className="text-black hover:text-gray-700">item-4</a>
        </nav> */}
        <div className="space-x-4 flex font-inter items-center text-sm md:text-base">
          <input
            type="text"
            placeholder="search"
            className="px-4 py-2 border rounded-full shadow-sm focus:outline-none font-light grow shrink"
          />
          <button className="text-black border border-black/40 rounded-full font-medium px-4 py-2">G sign in</button>
        </div>
      </header>
    )
}

